import Link from "next/link";
import Reveal from "@/components/ui/Reveal";
import { BOOK_DEMO_HREF } from "@/lib/marketing-links";

export default function FinalCta() {
  return (
    <section className="py-size-xl px-margin-mobile md:px-margin-desktop relative overflow-hidden bg-mkt-surface">
      <Reveal className="max-w-4xl mx-auto text-center relative z-10 px-size-md sm:px-size-lg py-size-lg sm:py-size-xl rounded-3xl border border-white/10 bg-mkt-inarax-black shadow-2xl">
        <h2 className="text-white font-display-lg text-headline-lg mb-size-sm">Build workforce AI capability</h2>
        <p className="text-white font-body-lg text-body-lg mb-size-lg text-balance">
          See how inaraX personalizes AI learning for every role in your organization.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-size-md">
          <Link
            href={BOOK_DEMO_HREF}
            className="w-64 sm:w-auto bg-mkt-primary-container text-mkt-on-primary font-headline-md text-body-lg sm:text-headline-sm text-center px-size-sm sm:px-size-xl py-size-sm sm:py-size-md rounded-lg primary-cta-glow transition-all hover:scale-105 active:scale-95"
          >
            Book a Consultation
          </Link>
          <Link
            className="w-64 sm:w-auto border border-white/20 text-white font-headline-md text-body-lg sm:text-headline-sm text-center px-size-sm sm:px-size-xl py-size-sm sm:py-size-md rounded-lg hover:bg-white/5 transition-all"
            href="/solutions"
          >
            Explore solutions →
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
